import {
    LiteTradeNotificationAccountTypeContainerStyled,
    LiteTradeNotificationAccountTypeStyled,
    LiteTradeNotificationDescriptionStyled,
    LiteTradeNotificationStatusIconContainerStyled,
    LiteTradeNotificationStyled,
} from './styled/LiteTradeNotificationStyled';
import BinIcon from '../../../../components/icon/Icon';
import { LITE_TRADE_NOTIFICATION_STATUSES } from './liteTradeNotificationConstants';
import { ACCOUNT_TYPES } from '../../../../app/appConstants';
import classNames from 'classnames';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import { getLiteTradeNotificationStatusByNotificationType } from './liteTradeNotificationUtils';
import { PropsWithChildren } from 'react';
import { IAccountType } from '../../../../app/types/appActions.t';
import { TLiteTradeNotificationStatus, TLiteTradeNotificationType } from './liteTradeNotification.t';
import { ILiteTradeAssetSymbol } from '../../types/liteTradeReducer.t';

type ILiteTradeNotificationProps = PropsWithChildren<{
    accountType: IAccountType;
    description?: string;
    iconName?: string;
    status?: TLiteTradeNotificationStatus;
    symbol?: ILiteTradeAssetSymbol;
    type: TLiteTradeNotificationType;
    withCloseButton?: boolean;
}>

function LiteTradeNotification(props: ILiteTradeNotificationProps) {
    const {
        accountType,
        children,
        description,
        iconName,
        status,
        symbol,
        type,
        withCloseButton = true,
    } = props;

    const { getLangPath } = useLangContext();
    const currentStatus = status || getLiteTradeNotificationStatusByNotificationType(type);

    return <LiteTradeNotificationStyled>
        <div className="d-flex align-items-center">
            <div className="d-flex flex-1 align-items-center">
                <LiteTradeNotificationStatusIconContainerStyled className={currentStatus}>
                    <BinIcon size={16} name={
                        iconName ||
                        (currentStatus === LITE_TRADE_NOTIFICATION_STATUSES.SUCCESS ? 'IcCheckMark' : 'IcCircleSlashed')
                    }/>
                </LiteTradeNotificationStatusIconContainerStyled>
                <div
                    className="ms-2 fw600 f16 text-primary">{getLangPath(`lite_version.notifications.title.${type}`, { symbol })}</div>
            </div>
            <LiteTradeNotificationAccountTypeContainerStyled className={classNames({
                'with-close-button': withCloseButton,
            })}>
                <LiteTradeNotificationAccountTypeStyled>
                    {getLangPath(`lite_version.home.${accountType === ACCOUNT_TYPES.LIVE
                        ? 'real'
                        : 'demo'
                    }`)}
                </LiteTradeNotificationAccountTypeStyled>
            </LiteTradeNotificationAccountTypeContainerStyled>
        </div>
        {!!description && <LiteTradeNotificationDescriptionStyled className="mt-2">
            {description}
        </LiteTradeNotificationDescriptionStyled>}
        {!!children && children}
    </LiteTradeNotificationStyled>;
}

export default LiteTradeNotification;
